import { createApi } from '@reduxjs/toolkit/query/react'
import { url } from 'inspector'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const GroupsAPI = createApi({
  reducerPath: 'GroupsAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Groups'],
  endpoints: builder => ({
    postGroups: builder.mutation({
      query: body => ({
        url: `/api/Groups`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Groups'],
    }),

    getGroups: builder.query({
      query: params => ({
        url: `/api/Groups`,
        method: 'GET',
        params,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Groups'],
    }),
    deleteGroups: builder.mutation({
      query: id => ({
        method: 'DELETE',
        url: `/api/Groups/${id}`,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Groups'],
    }),
    getGroupsById: builder.query({
      query: id => ({
        method: 'GET',
        url: `/api/Groups/${id}`,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Groups'],
    }),

    updateGroups: builder.mutation({
      query: body => ({
        method: 'PUT',
        url: `/api/Groups/${body.Id}`,
        headers: authHeaderAPI(),
        body,
      }),
      invalidatesTags: ['Groups'],
    }),
  }),
})
export const {
  useGetGroupsQuery,
  usePostGroupsMutation,
  useDeleteGroupsMutation,
  useGetGroupsByIdQuery,
  useUpdateGroupsMutation,
} = GroupsAPI
